import { getters } from '../store.js'

export const variablesMixin = {
    data: function() {
        return {
            variablesCopy: []
        }
    },
    computed: {
        generalVariables: function () {
            return this.variablesCopy.filter(v => !v.roomTypeReference);
        },
        roomTypeVariables: function() {
            return this.variablesCopy.filter(v => v.roomTypeReference);
        },
    },
    methods: {
        copyVariables: function (variables) {
            this.variablesCopy.splice(0, this.variablesCopy.length);
            this.variablesCopy.push(...variables);
        },
        fetchVariables: async function () {
            this.loading = true;
            try {
                const response = await this.$http.get('/guest-management/v1/establishments/' + getters.getCurrentEstablishment().reference + '/variables', {
                    withCredentials: true
                });
                console.log(response);
                if (response.data) {
                    let listOfSeenRoomTypeVariables = new Map();
                    for (let variable of response.data) {
                        if (variable.roomTypeReference) {
                            if (!listOfSeenRoomTypeVariables.has(variable.name)) {
                                listOfSeenRoomTypeVariables.set(variable.name, true);
                                variable.value = "e.g. " + variable.value;
                                this.variablesCopy.push(variable);
                            }
                        } else {
                            this.variablesCopy.push(variable);
                        }
                    }
                    // this.variablesCopy.push(...(new Set(response.data.map(v => v.name))));
                    this.sortVariables();
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.loading = false;
            }
        },
        sortVariables: function() {
            this.variablesCopy.sort(function(a, b) {
                return a.name.localeCompare(b.name);
            });
        },
        getExampleForVariable: function(variableName) {
            let variable = this.variablesCopy.find(v => v.name === variableName);
            if (variable && variable.exampleValue) {
                return variable.exampleValue;
                // if (variable.value === variable.exampleValue) {
                //     return variable.exampleValue;
                // } else {
                //     return variable.exampleValue.substring(0, 20);
                // }
            } else {
                return "";
            }
        }
    },
};